import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ShopProvider } from './context/ShopContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import { Toaster } from 'react-hot-toast';

// Lazy load potentially heavy pages
const Checkout = lazy(() => import('./pages/Checkout'));
const OrderConfirmation = lazy(() => import('./pages/OrderConfirmation'));
const Admin = lazy(() => import('./pages/Admin'));

// Simple loading spinner for Suspense fallback
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-[50vh]">
    <div className="w-8 h-8 border-4 border-mauve-base border-t-mauve-dark rounded-full animate-spin"></div>
  </div>
);

const App: React.FC = () => {
  return (
    <ShopProvider>
      <Router>
        <Layout>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Suspense>
        </Layout>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#89986D',
              color: '#F6F0D7',
            },
          }}
        />
      </Router>
    </ShopProvider>
  );
};

export default App;